import { useEffect, useState } from "react";
import "./style.scss";
import { Outlet, useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useTranslation } from "react-i18next";
import { ChangeLanguage } from "widgets/change-language";
import AuthChat from "../../../assets/AuthChat.svg";
import AuthBack from "../../../assets/AuthBack.svg";
import { AuthContactsModal } from "pages/onboarding/components/contacts-modal";
import { Capacitor } from "@capacitor/core";
// import { Crisp } from "crisp-sdk-web";
// import { useCrispVisibility } from "hooks/useCrispVisibility";

export const OnBoardingLayout = () => {
  const { t: o } = useTranslation("onboarding");
  const navigate = useNavigate();
  const [chatOpened, setChatOpened] = useState(false);

  return (
    <div className="onboarding-layout">
      <nav
        className={
          location.pathname !== PATH_LIST.welcome
            ? "navbar"
            : "navbar welcome-navbar"
        }
        style={{
          paddingTop: Capacitor.isNativePlatform() ? "16px" : "36px",
        }}
      >
        {location.pathname !== PATH_LIST.welcome && (
          <button
            onClick={() => navigate(-1)}
            style={{
              justifyContent: "flex-start",
            }}
          >
            <img className="go-back" src={AuthBack} alt="back" />
          </button>
        )}

        <div className="navbar-right">
          <ChangeLanguage
            dark={location.pathname !== PATH_LIST.welcome ? true : false}
          />
          {location.pathname !== PATH_LIST.welcome && (
            <button
              onClick={() => setChatOpened(true)}
              style={{
                justifyContent: "flex-end",
              }}
            >
              <img className="open-chat" src={AuthChat} alt="chat" />
            </button>
          )}
        </div>
      </nav>

      <Outlet />

      <div
        className="footer"
        style={{
          paddingBottom: Capacitor.isNativePlatform() ? "16px" : "28px",
        }}
      >
        {location.pathname !== PATH_LIST.residencyNationality && (
          <p>
            {o("alreadyHaveAccount")} <a href={PATH_LIST.login}>{o("logIn")}</a>
          </p>
        )}
      </div>
      {chatOpened && <AuthContactsModal onClose={() => setChatOpened(false)} />}
    </div>
  );
};

//  <CameraAccess />
